import * as React from 'react';

import { Redirect } from 'react-router-dom';
import { trackEvent } from '../api/analytics';

interface IMatch {
  path: string;
}

interface IProps {
  match: IMatch;
}

class NotFoundPage extends React.PureComponent<IProps> {
  public componentDidMount() {
    const { path } = this.props.match;
    // Send this to Segment, which will then get forwarded to Datadog
    trackEvent('legacy', 'not_found', 'exception', { path });
  }

  public render() {
    return <Redirect to="/" />;
  }
}

export default NotFoundPage;
